/*
 * Die Sinnbilder des Fortschrittsbalkens.
 *
 * Sie liegen als SVG im Quelltext und nicht als Datei unter `assets`: Ein
 * `<img>` kann seine Farbe nicht vom Zustand des Schritts erben — erledigt,
 * gerade dran und noch offen sehen aber verschieden aus. Gezeichnet wird
 * deshalb mit `currentColor`, die Farbe setzt das Stylesheet am Knoten.
 *
 * Achtung: In `App.module.scss` steht ein globales `svg { flex: 1 }`. Ohne
 * `flex: 0 0 auto` (siehe style.module.scss) zieht sich jedes Sinnbild auf die
 * Breite seines Flex-Kastens auf.
 */

const base = {
	viewBox: '0 0 24 24',
	fill: 'none',
	stroke: 'currentColor',
	strokeWidth: 1.7,
	strokeLinecap: 'round',
	strokeLinejoin: 'round',
	'aria-hidden': true,
	focusable: false
}

// Der Haken für erledigte Schritte — kräftiger als die übrigen Linien, er
// steht allein im Kreis.
export const IconCheck = props => (
	<svg {...base} strokeWidth={2.6} {...props}>
		<path d="m5.5 12.5 4.2 4.2L18.5 8" />
	</svg>
)

// Anmeldung: die Fahne am Start.
export const IconStart = props => (
	<svg {...base} {...props}>
		<path d="M5.5 21V3.8" />
		<path d="M5.5 4.5h10.8l-2.2 3.6 2.2 3.6H5.5" />
	</svg>
)

// Mitarbeiter:innen.
export const IconTeam = props => (
	<svg {...base} {...props}>
		<circle cx="9.2" cy="8.4" r="3.2" />
		<path d="M3.6 19.4a5.6 5.6 0 0 1 11.2 0" />
		<path d="M16.2 5.6a3.2 3.2 0 0 1 0 5.6" />
		<path d="M17.6 13.8a5.6 5.6 0 0 1 2.8 4.8" />
	</svg>
)

// Wirtschaftsexpert:innen.
export const IconExpert = props => (
	<svg {...base} {...props}>
		<circle cx="12" cy="8.6" r="4.1" />
		<path d="M9.1 12.4 7.6 20.4l4.4-2.4 4.4 2.4-1.5-8" />
	</svg>
)

// Markt- und Risikoanalyse.
export const IconAnalysis = props => (
	<svg {...base} {...props}>
		<path d="M4 3.8v16.4h16" />
		<path d="m7.2 15.8 3.6-4.4 2.9 2.5 5.1-6" />
	</svg>
)

// Businessplan und andere Unterlagen.
export const IconDocument = props => (
	<svg {...base} {...props}>
		<path d="M14 3.2H7.4a2 2 0 0 0-2 2v13.6a2 2 0 0 0 2 2h9.2a2 2 0 0 0 2-2V7.9z" />
		<path d="M14 3.2v4.7h4.6" />
		<path d="M9 13h6M9 16.4h4" />
	</svg>
)

// Prüfung: es liegt bei der Verwaltung.
export const IconWaiting = props => (
	<svg {...base} {...props}>
		<circle cx="12" cy="12" r="8.4" />
		<path d="M12 7.4V12l3.1 2.1" />
	</svg>
)

// Genehmigt: das Siegel mit dem Haken.
export const IconApproved = props => (
	<svg {...base} {...props}>
		<path d="m12 3.2 2.1 2.3 3.1-.4.6 3.1 2.7 1.6-1.5 2.7 1 3-3 1-1.2 2.9-3-1.1-2.9 1.1-1.3-2.9-3-1 1-3-1.5-2.7 2.7-1.6.6-3.1 3.1.4z" />
		<path d="m9.4 12.2 1.9 1.9 3.4-3.7" />
	</svg>
)

// Verkauf von Anteilen: der Anteilschein.
export const IconShares = props => (
	<svg {...base} {...props}>
		<rect x="3.4" y="4.4" width="17.2" height="11" rx="2" />
		<path d="M7 8.4h5M7 11.6h3" />
		<circle cx="16.4" cy="9.8" r="1.9" />
		<path d="m14.7 12.6-.5 4.2 2.2-1.3 2.2 1.3-.5-4.2" />
	</svg>
)

// Finanzbericht.
export const IconReport = props => (
	<svg {...base} {...props}>
		<rect x="4.2" y="3.4" width="15.6" height="17.2" rx="2" />
		<path d="M8.6 16.2v-3.4M12 16.2v-6.6M15.4 16.2v-4.6" />
	</svg>
)

// Abgaben entrichten: die Rechnung.
export const IconInvoice = props => (
	<svg {...base} {...props}>
		<path d="M6 3.4h12v17.2l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4-2 1.4z" />
		<path d="M9 8.8h6M9 12.4h6M9 15.8h3.5" />
	</svg>
)

// Geschäftsbericht: der Abschluss des Programms.
export const IconTrophy = props => (
	<svg {...base} {...props}>
		<path d="M8 3.8h8v4.6a4 4 0 0 1-8 0z" />
		<path d="M8 5.4H5.4v.9A3.6 3.6 0 0 0 9 9.9" />
		<path d="M16 5.4h2.6v.9A3.6 3.6 0 0 1 15 9.9" />
		<path d="M12 12.6v3.4" />
		<path d="M9 20.2h6l-.8-4.2H9.8z" />
	</svg>
)

// Welches Sinnbild zu welchem Schritt gehört (siehe steps.js).
export const ICONS = {
	start: IconStart,
	team: IconTeam,
	expert: IconExpert,
	analysis: IconAnalysis,
	document: IconDocument,
	waiting: IconWaiting,
	approved: IconApproved,
	shares: IconShares,
	report: IconReport,
	invoice: IconInvoice,
	trophy: IconTrophy
}
